import { List, ModelBase, NeoModel } from "@singularsystems/neo-core";
import ClientAccountLookup from "./ClientAccountLookup";

@NeoModel
export default class ClientLookup extends ModelBase {

    public clientId: number = 0;

    public staticCurrencyId: number = 0;

    public currencyCode: string = "";

    public clientNumber: string = "";

    public clientName: string | null = null;

    public clientDescription: string = "";

    public clientEntityTypeId: number | null = null;

    public clientEntityTypeName: string | null = null;

    public clientAccounts = new List(ClientAccountLookup);

    public isExpanded: boolean | null = null;
}